import {
  Box,
  Flex,
  Text,
  Icon,
  Badge,
  HStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { FiTrendingUp, FiDollarSign, FiArrowRight } from "react-icons/fi";
import { SuggestionWithSelectionProps } from "./types";

const SuggestionComparisonView = ({
  id,
  type,
  oldValue,
  newValue,
  change,
}: SuggestionWithSelectionProps) => {
  const difference = newValue - oldValue;
  const isPositive = newValue > oldValue;
  const isBid = type === "bid";
  const bgColor = useColorModeValue("white", "whiteAlpha.100");
  const textColor = useColorModeValue("gray.600", "gray.300");

  return (
    <Box 
      position="relative" 
      p={2} 
      borderRadius="md" 
      bg={bgColor} 
      mb={2}
      boxShadow="0 2px 6px rgba(0,0,0,0.15)"
    >
      <Flex justifyContent="space-between" alignItems="center">
        <HStack spacing={2} flex="1">
          <Icon as={isBid ? FiTrendingUp : FiDollarSign} color="brand.500" />
          <Text fontWeight="medium" fontSize="sm">
            {isBid ? "CPI" : "Budget"}:
          </Text>
        </HStack>

        <HStack spacing={2} flex="3">
          <Text fontWeight="bold" color={textColor}>
            ${oldValue.toFixed(2)}
          </Text>
          <Icon as={FiArrowRight} color="brand.400" />
          <Text fontWeight="bold" color="brand.500">
            ${newValue.toFixed(2)}
          </Text>
          <Badge colorScheme={isPositive ? "green" : "red"} ml={1}>
            {isPositive ? "+" : ""}${Math.abs(difference).toFixed(2)}
          </Badge>
        </HStack>
      </Flex>
    </Box>
  );
};

export default SuggestionComparisonView; 